import React, { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CustomerContext = createContext(null);

function loadJSON(key) {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  } catch {
    return null;
  }
}

function makeSession() {
  return (crypto?.randomUUID && crypto.randomUUID()) || `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function CustomerProvider({ children }) {
  const [caravan, setCaravanState] = useState(() => loadJSON("otm_caravan"));
  const [sessionId, setSessionId] = useState(() => {
    let s = localStorage.getItem("otm_session");
    if (!s) {
      s = makeSession();
      localStorage.setItem("otm_session", s);
    }
    return s;
  });

  const setCaravan = useCallback((c) => {
    setCaravanState(c);
    if (c) localStorage.setItem("otm_caravan", JSON.stringify(c));
    else localStorage.removeItem("otm_caravan");
  }, []);

  const lookupCaravan = useCallback(async (chassis) => {
    const { data } = await api.get(`/caravans/${encodeURIComponent(chassis.trim())}`);
    setCaravan(data);
    return data;
  }, [setCaravan]);

  const clearCaravan = useCallback(() => setCaravan(null), [setCaravan]);

  const newChat = useCallback(() => {
    const s = makeSession();
    localStorage.setItem("otm_session", s);
    setSessionId(s);
    return s;
  }, []);

  return (
    <CustomerContext.Provider
      value={{ caravan, setCaravan, lookupCaravan, clearCaravan, sessionId, newChat }}
    >
      {children}
    </CustomerContext.Provider>
  );
}

export function useCustomer() {
  const ctx = useContext(CustomerContext);
  if (!ctx) throw new Error("useCustomer must be used within CustomerProvider");
  return ctx;
}
